'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recentlyVisitedPropType = require('../PropTypes/recentlyVisitedPropType');

var _recentlyVisitedPropType2 = _interopRequireDefault(_recentlyVisitedPropType);

var _navigationSettingsPropType = require('../PropTypes/navigationSettingsPropType');

var _navigationSettingsPropType2 = _interopRequireDefault(_navigationSettingsPropType);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _RecentlyVisited = require('../RecentlyVisited');

var _RecentlyVisited2 = _interopRequireDefault(_RecentlyVisited);

var _TaxonomyNavigator = require('../TaxonomyNavigator');

var _TaxonomyNavigator2 = _interopRequireDefault(_TaxonomyNavigator);

var _defaultLinks = require('../NewNavigationBar/defaultLinks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HIERARCHY = ['🌍', 'Continent', 'Country', 'Region', 'Area'];

var CamsReportsMenu = function CamsReportsMenu(_ref) {
  var loggedIn = _ref.loggedIn,
      navigationSettings = _ref.navigationSettings,
      recentlyVisited = _ref.recentlyVisited,
      serviceConfig = _ref.serviceConfig,
      menuState = _ref.menuState,
      setMenuState = _ref.setMenuState,
      scrollMenuToTop = _ref.scrollMenuToTop,
      _onClickLink = _ref.onClickLink,
      signInUrl = _ref.signInUrl;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cams-reports-menu' },
    _react2.default.createElement(_RecentlyVisited2.default, {
      listType: 'spots',
      loggedIn: loggedIn,
      items: recentlyVisited,
      serviceConfig: serviceConfig,
      staticLinks: _defaultLinks.camsReportsLinks,
      signInUrl: signInUrl,
      onClickLink: function onClickLink(properties, closeMobileMenu) {
        return _onClickLink({
          name: 'Clicked Main Nav',
          properties: (0, _extends3.default)({}, properties, {
            tabName: 'Cams'
          })
        }, closeMobileMenu);
      }
    }),
    _react2.default.createElement(_TaxonomyNavigator2.default, {
      hierarchy: HIERARCHY,
      loggedIn: loggedIn,
      navigationSettings: navigationSettings,
      serviceConfig: serviceConfig,
      savedLocationType: 'spotsTaxonomyLocation',
      menuState: menuState,
      setMenuState: setMenuState,
      taxonomyType: 'spot',
      scrollMenuToTop: scrollMenuToTop,
      onClickLink: function onClickLink(properties, closeMobileMenu) {
        return _onClickLink({
          name: 'Clicked Main Nav',
          properties: (0, _extends3.default)({}, properties, {
            tabName: 'Cams'
          })
        }, closeMobileMenu);
      }
    })
  );
};

CamsReportsMenu.propTypes = {
  loggedIn: _propTypes2.default.bool,
  navigationSettings: _navigationSettingsPropType2.default,
  recentlyVisited: _propTypes2.default.arrayOf(_recentlyVisitedPropType2.default),
  serviceConfig: _serviceConfigurationPropType2.default,
  setMenuState: _propTypes2.default.func.isRequired,
  menuState: _propTypes2.default.shape().isRequired,
  scrollMenuToTop: _propTypes2.default.func,
  signInUrl: _propTypes2.default.string.isRequired,
  onClickLink: _propTypes2.default.func
};

CamsReportsMenu.defaultProps = {
  loggedIn: false,
  scrollMenuToTop: null,
  onClickLink: null
};

exports.default = CamsReportsMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamsReportsMenu/CamsReportsMenu.js
// module id = 273
// module chunks = 0